export default __webpack_public_path__ + "static/media/client12.6c6b0b09.jpg";